<template>
  <div>
    <!-- Modal -->
    <div class="modal fade" id="sendOrdersModal" ref="modalEle" tabindex="-1" role="dialog"
         aria-labelledby="modelTitleId"
         aria-hidden="true">
      <div class="modal-dialog modal-xl" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Wyślij zamówienia</h5>
            <button type="button" class="close ms-auto" data-bs-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body" v-if="selectedItems">

            <div class="mb-3">Wiadomość e-mail będzie zawierała wszystkie pozycje z danego zamówienia, niezależnie od
              tego, czy wszystkie zostały zaznaczone. <br>
              Oznacza to, że zostaną wysłane maile ze wszystkimi pozycjami z poniższego zamówienia.
            </div>

            <div class="table-responsive container-fluid">

              <table class="table table-striped">
                <thead>
                <tr>
                  <th>Nr Zamówienia</th>
                  <th>Projekt</th>
                  <th>Zespół</th>
                  <th>Wybrany dostawca</th>
                  <th>Maile</th>
                  <th>Maile DW</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(order, k) in orders">
                  <td>{{ order.order_number }}</td>
                  <td>{{ order.project }}</td>
                  <td>{{ order.team_name }}</td>
                  <td>{{ order.supplier }}</td>
                  <td>{{ order.send_to_mails }}</td>
                  <td>{{ order.send_to_mails_dw }}</td>
                </tr>
                </tbody>
              </table>
            </div>
<div class="row mb-4" v-if="orders?.[0]?.comment">
  <div class="col-md-12">
    <label class="fw-bold mb-2">Komentarz do zamówienia</label>

    <div class="alert alert-light border">
      {{ orders[0].comment }}
    </div>

    <div class="form-check mt-2">
      <input
        id="includeComment"
        v-model="includeComment"
        class="form-check-input"
        type="checkbox"
      >

      <label class="form-check-label" for="includeComment">
        Dołącz komentarz do wiadomości
      </label>
    </div>
  </div>
</div>
<div class="row mb-4" v-if="files.length">
  <div class="col-md-12">
    <label class="fw-bold">Załączniki do zamówienia</label>

    <ul class="list-group">
      <li
        v-for="(file, index) in files"
        :key="file.id"
        class="list-group-item d-flex justify-content-between align-items-center"
      >
        <span>
          <i class="bi bi-paperclip me-2"></i>
          {{ file.original_name }}
        </span>

        <button
          type="button"
          class="btn btn-sm btn-outline-danger"
          @click="removeFile(index)"
          title="Usuń załącznik"
        >
          <i class="bi bi-trash"></i>
        </button>
      </li>
    </ul>
  </div>
</div>

<div v-else class="alert alert-secondary">
  Brak załączników do wysłania.
</div>


          </div>

          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">
              <i class="bi bi-x-square me-2"></i>Zamknij
            </button>
            <button type="button" class="btn btn-outline-primary" @click="previewOrder">
              <i class="bi bi-box-arrow-up-right me-2"></i> Podgląd
            </button>
            <button type="button" class="btn btn-outline-danger" @click="downloadPdf" :loading="isDownloadingPdf">
              <i class="bi bi-file-earmark-pdf me-2"></i> Pobierz PDF
            </button>
            <form @submit.prevent="sendOrders">
              <button type="submit" class="btn btn-primary"
                      :disabled="isSending">
                <i class="bi bi-save me-2"></i>Wyślij powyższe zamówienia
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import {Modal, Tooltip} from "bootstrap";
import {DatePickerComponent} from "@syncfusion/ej2-vue-calendars";

export default {
  components: {'ejs-datepicker': DatePickerComponent},
  props: {
    project: Number | String,
    team: String,
    selectedItems: Object,
    checkWarehouses: true
  },

  data() {
    return {
      orders: null,
	   files: [],
      errors: {},
      isSending: false,
	  isDownloadingPdf: false,
	  includeComment: true,
    }
  },

watch: {
  selectedItems: {
    immediate: true,
    handler(newValue) {
      if (newValue) {
        this.orders = newValue.filter(
          (item, index, self) =>
            index === self.findIndex(
              (t) => t.order_lists_id === item.order_lists_id
            )
        );

        this.files = this.orders[0]?.order_files?.map(file => ({
          id: file.id,
          original_name: file.original_name,
          file_path: file.file_path,
        })) || [];
this.includeComment = true;
      } else {
        this.orders = null;
        this.files = [];
		this.includeComment = true;
      }
    }
  }
},

  async mounted() {
    this.modalObj = new Modal(this.$refs.modalEle);
		  this.$refs.modalEle.addEventListener('hidden.bs.modal', () => {
    this.$emit('clear-selection');
  });
    new Tooltip(document.body, {
      selector: "[data-bs-toggle='tooltip']",
    })
  },

  methods: {

  removeFile(index) {
  this.files.splice(index, 1);
},

  async downloadPdf() {
    this.isDownloadingPdf = true;

    try {
        const response = await axios.post(
            route('orders.pdf'),
            { orders: this.orders },
            {
                responseType: 'blob'
            }
        );

        const blob = new Blob([response.data], {
            type: 'application/pdf'
        });

        const url = window.URL.createObjectURL(blob);

        const link = document.createElement('a');
        link.href = url;
        const orderNumber = this.orders?.[0]?.order_number || 'Order';
const safeOrderNumber = orderNumber.replace(/\//g, '_');

link.download = `Order_${safeOrderNumber}.pdf`;

        document.body.appendChild(link);
        link.click();

        link.remove();
        window.URL.revokeObjectURL(url);

    } catch (error) {
        console.error(error);
        this.$emit('added-error', 'Nie udało się wygenerować PDF.');
    }

    this.isDownloadingPdf = false;
},

async sendOrders() {
  this.isSending = true;

  await axios.post(route('orders.send'), {
    orders: this.orders,
    files: this.files,
	include_comment: this.includeComment
  })
    .then(response => {
      this.$emit('added-success', response.data);
      this.$emit('clear-selection');
      this.$emit('refresh', true);
    })
    .catch(error => {
      console.log(error);
      this.$emit('added-error', error.response?.data || 'Błąd podczas wysyłania zamówienia.');
    });

  this.isSending = false;
  this.hide();
},

    previewOrder() {
      axios.post(route('orders.preview'), {orders: this.orders})
          .then(response => {
            const previewWindow = window.open('', '_blank');
            previewWindow.document.open();
            previewWindow.document.write(response.data); // wstawia HTML z laravela
            previewWindow.document.close();
          })
          .catch(error => {
            console.error('Błąd podglądu zamówienia:', error);
          });
    },

    show() {
      if (this.modalObj) {
        this.modalObj.show();
      }
    },
    hide() {
      if (this.modalObj) {
        this.modalObj.hide();
      }
    },
  }
}
</script>